// Status filter options for drafts
export const statusFilterOptions = [
	{ label: 'All', value: '' },
	{ label: 'Draft', value: 'draft' },
];

// Draft Type filter options
export const draftTypeFilterOptions = [
	{ label: 'All', value: '' },
	{ label: 'Patient Order Form', value: 'Patient Order Form' },
	{ label: 'Clinic Order Form', value: 'Clinic Order Form' },
	{ label: 'Return Order Form', value: 'Return Order Form' },
	{ label: 'Consignment Order Form', value: 'Consignment Order Form' },
	{ label: 'Benefit Verification Form', value: 'Benefit Verification Form' },
	{ label: 'Patient Form', value: 'Patient Form' },
	{ label: 'Support Ticket Form', value: 'Support Ticket Form' },
];
